import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDc0IhopVwoDyNn6qv8K9xk1pd1act6dhI',
    libraries: 'places'
  }
})

Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )

Vue.config.productionTip = false

document.title = 'WUSTONE'
new Vue({
  render: h => h(App),
  router
}).$mount('#app')